module.exports = __webpack_public_path__ + "img/vessels.bcacae07.png";